<form   [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSubmit()" style="max-width: 700px;">

 <div *ngIf="!produtoSelecionado || !produtoSelecionado.id">
   <h4 [hidden]="editandoItemMesa">
     Escolha o Produto que deseja adicionar
   </h4>
   <div [hidden]="editandoItemMesa">
     <small class="">Dica: Duplo clique também seleciona o produto.</small>
   </div>
   <div class="tabela-precos-carregada" *ngIf="tabelaDePrecosCarregada">
     <span>Tabela de preços carregada</span>
     <strong>{{ tabelaDePrecosCarregada.nome }}</strong>
     <small *ngIf="tabelaDePrecosCarregada.canalLabel">{{ tabelaDePrecosCarregada.canalLabel }}</small>
   </div>


   <kendo-grid #gridProdutos [data]="gridDataResult"
               [loading]="loading"
               [height]="alturaGrid"
               [scrollable]="'scrollable'" [sortable]="true" [sort]="this.state.sort"
               [groupable]="false"
               [selectable]="configuracoesDeSelecao"
               [filter]="state.filter"
               (dblclick)="duploClique($event)"
               (selectionChange)="selecionouProduto($event)"
               (dataStateChange)="dataStateChange($event)">
     <kendo-grid-messages
       pagerPage="Página"
       pagerOf="de"
       pagerItems="itens"
       noRecords="Cadastre Produtos do Pedido"
       loading="Carregando"
       pagerItemsPerPage="ítems por página"
     >
     </kendo-grid-messages>
     <ng-template kendoGridToolbarTemplate>
       <input kendoTextBox placeholder="Busque por Código ou Nome"  *ngIf="!editando"
              class="form-control w-100" appAutoFocus (input)="onFilterEvento($event)"/>
     </ng-template>
     <kendo-grid-column-group title="Teste" [width]="10">
      <kendo-grid-column field="categoria.nome" title="Categoria" [hidden]="true">
       <ng-template kendoGridGroupHeaderTemplate let-value="value">
         {{value}}
       </ng-template>
     </kendo-grid-column>
     </kendo-grid-column-group>
     <kendo-grid-column title="Cod" [width]="65" [style]="{padding: '8px 6px'}" [headerStyle]="{verticalAlign: 'middle', padding: '8px 6px'}">
       <ng-template kendoGridHeaderTemplate>
            <span style="font-size:11px;">
              Cód.
            </span>
       </ng-template>
       <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span style="font-size:12px;">
          {{dataItem.id}}
        </span>
       </ng-template>
     </kendo-grid-column>
     <kendo-grid-column field="nome" title="Produto" [style]="{padding: '8px 6px'}">
       <ng-template kendoGridHeaderTemplate style="vertical-align: middle;">
         <span style="font-size:13px;">Produto</span>
       </ng-template>
       <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span style="font-size:12px;">
          {{dataItem.nome}}
        </span>
       </ng-template>
     </kendo-grid-column>
     <kendo-grid-column title="Preço" [width]="100" headerClass="centralizado">
       <ng-template kendoGridHeaderTemplate>
        <span style="font-size:11px;">
          Preço
        </span>
       </ng-template>
       <ng-template kendoGridCellTemplate let-dataItem  >
         <ng-container *ngIf="!dataItem.valorResgate">
            <span class="font-12" *ngIf="!dataItem.valorMinimo">
              {{ (dataItem.novoPreco ? dataItem.novoPreco : dataItem.preco) | currency:"BRL"}}
                    <span class="  font-13" *ngIf="exibirUnidade(dataItem)"> / kg </span>
              </span>

               <span class="font-12  " *ngIf="dataItem.valorMinimo">
                A partir de {{dataItem.valorMinimo | currency:"BRL"}}
             </span>
         </ng-container>
         <ng-container *ngIf="dataItem.valorResgate">
             <span class="font-12">
               {{dataItem.valorResgate}} pts
             </span>

         </ng-container>



       </ng-template>
     </kendo-grid-column>
     <kendo-grid-column field="nome" title="Produto" [width]="110" media="sm" [style]="{padding: '8px 6px'}">
       <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <button class="btn btn-primary btn-sm" (click)="selecionarProduto(dataItem)">Selecionar</button>
       </ng-template>
     </kendo-grid-column>
   </kendo-grid>

   <div class="mt-3" *ngIf="!editando">
     <button class="btn btn-blue btn-block d-lg-none" type="button" (click)="selecionarProdutoBtn()" [disabled]="!produtoSelecionadoNaGrid">Selecionar Produto</button>
   </div>
 </div>

  <div *ngIf="produtoSelecionado">
    <div class="row">
      <h4 class="col-12 mb-0">
        <button class="btn btn-outline-blue btn-rounded" (click)="cancelar()"><i class="fa fa-arrow-left ct-point"></i></button>
        &nbsp;<strong>{{produtoSelecionado.nome}}</strong>
      </h4>
      <div class="col-12 mb-3 text-center" *ngIf="exibirUnidade(produtoSelecionado)">
        <span class="text-muted font-14">{{produtoSelecionado.preco | currency:'BRL'}} por KG</span>
      </div>
      <div class="col-12 mt-2"></div>

      <ng-container *ngIf="!exibirUnidade(produtoSelecionado)">
        <div class="col-12 col-sm-6">
          <div class="form-group mb-12">
            <label for="qtdeDeItens">Qtde. Itens</label>


            <kendo-numerictextbox id="qtdeDeItens" name="qtdeDeItens" class="form-control" [(ngModel)]="itemPedido.qtde"
                                  [format]="obtenhaFormato()" [step]="obtenhaIncremento()" (valueChange)="itemPedido.atualizeTotal()"
                                  (keydown.enter)="editando ? atualizeProduto() : adicionarProduto()"
                                  appRemovaWheel  [min]="0"   [autoCorrect]="true">
            </kendo-numerictextbox>

            <small *ngIf="itemPedido.qtde === 0" class="text-danger ml-1"><b>item será removido</b></small>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="exibirUnidade(produtoSelecionado)">
        <div class="col-12 mb-2">
          <div class="alert alert-light border text-center p-2 mb-2 bg-white">
            <div class="mb-1 font-weight-bold" role="status"
                 [class.text-danger]="!!balancaSerial.erro"
                 [class.text-warning]="!!balancaSerial.avisoLeitura"
                 [class.text-success]="balancaSerial.comunicacaoValidada && !balancaSerial.erro && !balancaSerial.avisoLeitura && !balancaSerial.ocupada">
              <i class="fas fa-circle font-10"></i> {{ balancaSerial.status }}
            </div>
            <small class="text-muted">{{ balancaSerial.conectada ? balancaSerial.perfil.nome + ' · Leia o peso ou informe manualmente' : 'Insira o peso manualmente ou conecte a balança' }}</small>
            <div class="mt-2">
              <button type="button" class="btn btn-blue btn-sm mr-2" *ngIf="balancaSerial.conectada"
                      [disabled]="balancaSerial.ocupada || lendoPesoBalanca" (click)="lerPesoBalanca()">
                {{ lendoPesoBalanca ? 'Lendo peso…' : 'Ler peso' }}
              </button>
              <button type="button" class="btn btn-outline-blue btn-sm" (click)="abrirConfiguracaoBalanca()">
                {{ balancaSerial.conectada ? 'Configurar balança' : 'Conectar balança' }}
              </button>
            </div>
            <small class="d-block text-danger mt-2" role="alert" *ngIf="erroBalanca || balancaSerial.erro">{{ erroBalanca || balancaSerial.erro }}</small>
            <small class="d-block text-warning mt-2" *ngIf="balancaSerial.avisoLeitura && !erroBalanca">{{ balancaSerial.avisoLeitura.message }}</small>
          </div>
        </div>

        <div class="col-5">
          <div class="form-group">
            <label class="font-weight-bold">Peso do item</label>
            <kendo-numerictextbox name="qtdeDeItensPeso" class="form-control" [(ngModel)]="itemPedido.qtde"
                                  [disabled]="lendoPesoBalanca"
                                  [format]="obtenhaFormato()" [step]="obtenhaIncremento()" (valueChange)="itemPedido.atualizeTotal()"
                                  (keydown.enter)="editando ? atualizeProduto() : adicionarProduto()"
                                  appRemovaWheel [min]="0" [autoCorrect]="true" appAutoFocus>
            </kendo-numerictextbox>
          </div>
        </div>

        <div class="col-2 d-flex align-items-center justify-content-center pt-3">
          <i class="fas fa-exchange-alt text-muted font-20"></i>
        </div>

        <div class="col-5">
          <div class="form-group">
            <label class="font-weight-bold">Valor calculado</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white border-right-0">R$</span>
              </div>
              <input type="text" class="form-control bg-light border-left-0 pl-1" [value]="itemPedido.total | number:'1.2-2'" readonly>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <small class="text-muted">Calculado automaticamente com base no peso por {{produtoSelecionado.unidadeMedida?.sigla}}</small>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="produtoSelecionado">

      <ng-container *ngIf="produtoSelecionado.tamanhos">

        <app-adicionais-customizados #adicionaisCustomizados
                                     (alterouTamanho)="onAlterouTamanho($event)"   [itemPedido]="itemPedido" [produto]="produtoSelecionado">

        </app-adicionais-customizados>

      </ng-container>


      <div *ngFor="let campoAdicional of produtoSelecionado.camposAdicionais">
        <app-site-campo-adicional #adicionalComponent [campoAdicional]="campoAdicional" [itemPedido]="itemPedido" [posicao]="campoAdicional.posicao"
                (onDesmarcouOpcao)="desmarcouNovaOpcao($event)"     (onMarcouOpcao)="escolheuNovaOpcao($event)" ></app-site-campo-adicional>

      </div>

      <ng-container *ngFor="let sabor of itemPedido.sabores">
        <ng-container *ngIf="sabor.produto !== itemPedido.produto?.id">
          <div *ngFor="let adicionalSabor of sabor.camposAdicionais">

            <app-site-campo-adicional #adicionalComponent [id]="'adicional_' + adicionalSabor.id" [campoAdicional]="adicionalSabor"
                                      [itemPedido]="itemPedido" [posicao]="adicionalSabor.posicao"
                                      [exibirSabor]="true"  [tamanhoSabor]="sabor.produtoTamanho"
                                      (onDesmarcouOpcao)="desmarcouNovaOpcao($event)"  (onMarcouOpcao)="escolheuNovaOpcao($event)" ></app-site-campo-adicional>
          </div>
        </ng-container>
      </ng-container>

    </ng-container>

    <div class="mt-2" [hidden]="editandoItemMesa">
      <div class="form-group  ">
        <label>Desconto no produto</label>

        <div class="input-group">
          <kendo-numerictextbox name="descontoItem"   format="c2" appRemovaWheel  class="form-control"
                                [(ngModel)]="itemPedido.desconto" [min]="0"     >
          </kendo-numerictextbox>
        </div>
      </div>

      <div class="mt-3"></div>
      <div class="form-group mb-3">
        <label for="observacao"><i class="fas fa-comment-dots"></i> Alguma Observação?</label>
        <textarea type="text" class="form-control" autocomplete="off" maxlength="255"
                  id="observacao" name="observacao" [(ngModel)]="itemPedido.observacao" #observacao="ngModel"
                  placeholder="Inclua alguma observação sobre este item no pedido." value="" required>
        </textarea>

        <div class="invalid-feedback">
        </div>
      </div>

    </div>

    <p class="text-danger mt-1"><b>{{mensagemErro}}</b></p>

    <div class="mt-3">
      <button class="btn btn-blue btn-block py-2" type="button" (click)="adicionarProduto()" [disabled]="!produtoSelecionado || lendoPesoBalanca" *ngIf="!editando">
        <span *ngIf="exibirUnidade(produtoSelecionado)">[ Enter ] </span> Adicionar
      </button>
      <button class="btn btn-blue btn-block py-2" type="button" (click)="atualizeProduto()" [disabled]="lendoPesoBalanca" *ngIf="editando">
        <span *ngIf="exibirUnidade(produtoSelecionado)">[ Enter ] </span> Atualizar
      </button>
      <button class="btn btn-secondary btn-block py-2" type="button" (click)="cancelar()">Cancelar</button>
    </div>
  </div>
</form>
